import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IListView } from '@shared/interfaces/various/IListView';
import { IOrgPath, IResponsible, ResponsibleType } from '@shared/interfaces';

@Component({
    selector: 'app-org-breadcrumb',
    templateUrl: './org-breadcrumb.component.html',
    styleUrls: ['./org-breadcrumb.component.scss'],
    standalone: false
})
export class OrgBreadcrumbComponent {
    @Output() clickNodeEvent = new EventEmitter<IOrgPath>();

    orgPath: IOrgPath[];
    private _node: IListView<IResponsible> & Partial<IResponsible>;

    get node(): IListView<IResponsible> & Partial<IResponsible> {
        return this._node;
    }

    @Input() set node(val: IListView<IResponsible> & Partial<IResponsible>) {
        this._node = val;
        const typePath = [
            {
                orgDescription: this._node?.responsibleType === ResponsibleType.sag ? 'Siemens AG' : 'Lead Countries',
                responsibleType: this._node?.responsibleType
            }
        ];

        const orgPath = this._node?.orgPath;
        this.orgPath = this._node?.orgPath ? [...typePath, ...orgPath] : this._node?.responsibleType ? typePath : null;
    }

    constructor() {
        /* Constructor */
    }

    changeNode(value: IOrgPath) {
        this.clickNodeEvent.emit(value);
    }
}
